import { z } from 'zod';
import { fromPrismaDate, isCalendarDate, isStorableCalendarDate, isValidTimeZone, isWallTime, parseCalendarDate, } from '../../dates/index.js';
import { calEventInstants } from '../../events/cal-event-instants.js';
export const CAL_EVENT_END_BEFORE_START_MESSAGE = 'End date/time must be after start date/time.';
/** A kind-2 wall date: `YYYY-MM-DD` from a form, or the LocalDate scalar's UTC-midnight `Date`. */
function wallDate(label) {
    const required = `${label} date is required.`;
    const invalid = `${label} date is not a valid date.`;
    return z.union([z.string(), z.date()], { error: required }).transform((value, context) => {
        if (value === '') {
            context.addIssue({ code: 'custom', message: required });
            return z.NEVER;
        }
        let day;
        try {
            day = value instanceof Date ? fromPrismaDate(value) : parseCalendarDate(value);
        }
        catch {
            day = null;
        }
        if (isStorableCalendarDate(day))
            return day;
        context.addIssue({ code: 'custom', message: invalid });
        return z.NEVER;
    });
}
const wallTime = (message) => z.string({ error: message }).refine(isWallTime, message);
/** An event's start and end as wall date + `HH:mm` in its place's zone; the server derives the instants. */
export const calEventScheduleShape = {
    startDate: wallDate('Start'),
    startTime: wallTime('Start time is required.'),
    endDate: wallDate('End'),
    endTime: wallTime('End time is required.'),
};
// WHY: with no zone the server defaults one from the venue state; UTC has no DST, so this compares
// the wall clocks, and the create path checks again in the zone it resolves.
function endsBeforeStart({ startDate, startTime, endDate, endTime, timeZone }) {
    const zone = timeZone ?? 'UTC';
    if (!isCalendarDate(startDate) || !isCalendarDate(endDate))
        return false;
    if (!isWallTime(startTime) || !isWallTime(endTime) || !isValidTimeZone(zone))
        return false;
    const { dateStart, dateEnd } = calEventInstants({ startDate, startTime, endDate, endTime }, zone);
    return dateEnd <= dateStart;
}
export function refineCalEventSchedule(values, context) {
    if (!endsBeforeStart(values))
        return;
    context.addIssue({
        code: 'custom',
        message: CAL_EVENT_END_BEFORE_START_MESSAGE,
        path: ['endTime'],
    });
}
//# sourceMappingURL=cal-event-schedule-schema.js.map